<template lang="pug">
.section
  .section(v-if='isLoop')
    h4.warning(id="DialogReplace-loopWarning") {{ $t('Cannot replace - loop detected') }}
  .dialog-container(v-if='this.$store.state.Medium.playitems_selected_right.length > 0 && this.$store.state.Medium.media_selected_left.length > 0')
    el-row.row(v-if='type === "mediumReplace"')
      button.invisible(style='opacity: .01', ref="submitButton", @keyup.enter="replaceMediumInNetwork()") {{  'invisible button '}}
      span {{ $t('Replace all occurences of a Medium in network') }}
      hr.header
      el-col.col-left(:span="10")
        h4 {{$t('New Medium')}}
        hr.header
        ShortMediaList(id="DialogReplace-mediumNewMediumList" ref='childrenList', :items='[newMedium]', :showThumbs="true", :showMediaIcons="true")
      el-col.col-middle(:span="4")
        el-button.confirm(id="DialogReplace-mediumReplaceButton" v-if='!saving', type="success", @click="replaceMediumInNetwork()", circle)
          font-awesome-icon.linker-icon(icon="exchange-alt")
          | &nbsp; {{$t("replace")}} &nbsp;
        el-button.confirm.spinner(v-if='saving', type="primary", disabled, circle)
          font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
          .spinner-text {{ percentDone }}%
      el-col.col-right(:span="10")
        .media(v-if='this.$store.state.Medium.playitems_selected_right.length === 1')
          h4 {{$t('Old medium')}}
          hr.header
          ShortMediaList(id="DialogReplace-mediumOldMediumList" ref='targetsListMedium', :items='[this.$store.state.Medium.playitems_selected_right[0].Medium]', :showThumbs="true", :showMediaIcons="true")
    el-row(v-if='type === "mediumReplace"')
      hr.header
      MediumInPlaylists(id="DialogReplace-mediumReplaceAffected" v-if='this.$store.state.Medium.playitems_selected_right.length === 1', :medium='this.$store.state.Medium.playitems_selected_right[0].Medium', operation='replace')
    el-row.row(v-if='type === "playitemReplace"')
      button.invisible(style='opacity: .01', ref="submitButton", @keyup.enter="replaceMediumInPlayItem()") {{  'invisible button '}}
      span
        span {{ $t('Replace Medium in Playlist/Layout ') }}
        span.bolder(v-if='this.$store.state.Medium.media_selected_right[0]') {{ this.$store.state.Medium.media_selected_right[0].name }}
        span {{ $t(' at position ')}}
        span.bolder {{ this.$store.state.Medium.playitems_selected_right[0].order + 1 }}
      hr.header
      el-col.col-left(:span="10")
        h4 {{$t('New Medium')}}
        hr.header
        ShortMediaList(id="DialogReplace-playitemNewMedium" ref='childrenList', :items='[newMedium]', :showThumbs="true", :showMediaIcons="true")
      el-col.col-middle(:span="4")
        el-button.confirm(v-if='!saving', :type="!isLoop ? 'success' : 'default'", @click="replaceMediumInPlayItem()", circle, danger, :disabled='isLoop')
          font-awesome-icon.linker-icon(icon="exchange-alt")
          | &nbsp; {{ !isLoop ? $t("replace") : $t("replace") }} &nbsp;
        el-button.confirm.spinner(v-if='saving', type="primary", disabled, circle)
          font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
          .spinner-text {{ percentDone }}%
      el-col.col-right(:span="10")
        .media(v-if='this.$store.state.Medium.playitems_selected_right.length === 1')
          h4 {{$t('Old Medium')}}
          hr.header
          ShortMediaList(id="DialogReplace-playitemOldMedium" ref='targetsListMedium', :items='[this.$store.state.Medium.playitems_selected_right[0].Medium]', :showThumbs="true", :showMediaIcons="true")
    el-row(v-if='type === "playitemReplace"')
      hr.header
      MediumInPlaylists(id="DialogReplace-playitemAffected" :medium='this.$store.state.Medium.media_selected_right[0]', :onlyPreview='true')
    el-row(v-if='type === "helpHint"')
      h3 {{ $t('In order to enable "replace", you have to ')}}
        span {{ $t('select new medium in Library on the left, and select an element of playlist on the right.')}}
</template>

<script>

import Vue from 'vue'
import ShortMediaList from '../Common/ShortMediaList'
import MediumInPlaylists from '../Medium/MediumInPlaylists'

export default {
  props: ['type', 'newMedium'],
  components: {
    ShortMediaList,
    MediumInPlaylists
  },
  async created () {
    this.isLoop = await this.getIsLoopStatus()
    this.$nextTick(() => {
      this.$refs.submitButton.focus()
    })
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: 0,
      isLoop: false
    }
  },
  methods: {
    async replaceMediumInNetwork () {
      this.$emit('linkerJobStarted')
      this.saving = true
      try {
        await Vue.axios
          .post(`medium/replaceMedium`, { oldMediumId: this.$store.state.Medium.playitems_selected_right[0].Medium.id, newMediumId: this.$store.state.Medium.media_selected_left[0].id })
      } finally {
        this.$emit('linkerJobDone', 'replaceInNetwork')
      }
      this.saving = false
      this.percentDone = 100
      this.percentDone = 0
    },
    async getIsLoopStatus () {
      const isLoop = await Vue.axios
        .post(`medium/checkForLoop`, {
          Parent: this.$store.state.Medium.media_selected_right[0].id,
          Child: this.$store.state.Medium.media_selected_left[0].id
        })
        .then(response => {
          return response.data
        })
      this.saving = false
      return isLoop
    },
    async replaceMediumInPlayItem () {
      if (this.isLoop) return false
      this.saving = true
      this.$emit('linkerJobStarted')
      try {
        await Vue.axios
          .patch(
            `PlayListItem/${this.$store.state.Medium.playitems_selected_right[0].id}`,
            { Medium: this.$store.state.Medium.media_selected_left[0].id }
          )
      } finally {
        this.$emit('linkerJobDone', 'replaceInPlaylist')
      }
      this.$emit('close-playListItemReplace')
      this.saving = false
      this.percentDone = 100
      this.percentDone = 0
    }
  },
  computed: {
    desktopPlayListsSelected () {
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogReplace.vue